/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: Date | string | number;
  FullText: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
};

/**
 * A `Baseline` is what a `Snapshot` is compared to.
 *
 * For a new `Snapshot`, the matching `Baseline` is found based on the following properties:
 * - `name`
 * - `testName`
 * - `suiteName`
 * - `browser`
 * - `operatingSystem`
 * - `operatingSystemVersion`
 * - `viewportWidth`
 * - `viewportHeight`
 * - `project`
 * - `branch`
 * - `device`
 */
export type Baseline = Node & {
  __typename?: 'Baseline';
  branch: Maybe<Scalars['String']>;
  browser: Maybe<Browser>;
  browserVersion: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdByOrgId: Scalars['UUID'];
  createdByUser: User;
  createdByUserId: Scalars['UUID'];
  device: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Diff`. */
  diffs: DiffsConnection;
  hash: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  imageUrl: Scalars['String'];
  isLatest: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operatingSystem: Maybe<OperatingSystem>;
  operatingSystemVersion: Maybe<Scalars['String']>;
  project: Maybe<Scalars['String']>;
  /** Reads a single `Snapshot` that is related to this `Baseline`. */
  snapshot: Maybe<Snapshot>;
  snapshotId: Maybe<Scalars['UUID']>;
  suiteName: Maybe<Scalars['String']>;
  testName: Maybe<Scalars['String']>;
  uploadId: Scalars['String'];
  viewportHeight: Maybe<Scalars['Int']>;
  viewportWidth: Maybe<Scalars['Int']>;
};


/**
 * A `Baseline` is what a `Snapshot` is compared to.
 *
 * For a new `Snapshot`, the matching `Baseline` is found based on the following properties:
 * - `name`
 * - `testName`
 * - `suiteName`
 * - `browser`
 * - `operatingSystem`
 * - `operatingSystemVersion`
 * - `viewportWidth`
 * - `viewportHeight`
 * - `project`
 * - `branch`
 * - `device`
 */
export type BaselineDiffsArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<DiffCondition>;
  filter: InputMaybe<DiffFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiffsOrderBy>>;
};

/**
 * A condition to be used against `Baseline` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BaselineCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdByOrgId` field. */
  createdByOrgId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `hash` field. */
  hash: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `snapshotId` field. */
  snapshotId: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `Baseline` object types. All fields are combined with a logical ‘and.’ */
export type BaselineFilter = {
  /** Filter by the object’s `createdAt` field. */
  createdAt: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByOrgId` field. */
  createdByOrgId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id: InputMaybe<UuidFilter>;
  /** Filter by the object’s `snapshotId` field. */
  snapshotId: InputMaybe<UuidFilter>;
};

/** A connection to a list of `Baseline` values. */
export type BaselinesConnection = {
  __typename?: 'BaselinesConnection';
  /** A list of edges which contains the `Baseline` and cursor to aid in pagination. */
  edges: Array<BaselinesEdge>;
  /** A list of `Baseline` objects. */
  nodes: Array<Baseline>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Baseline` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Baseline` edge in the connection. */
export type BaselinesEdge = {
  __typename?: 'BaselinesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Baseline` at the end of the edge. */
  node: Baseline;
};

/** Methods to use when ordering `Baseline`. */
export enum BaselinesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByOrgIdAsc = 'CREATED_BY_ORG_ID_ASC',
  CreatedByOrgIdDesc = 'CREATED_BY_ORG_ID_DESC',
  CreatedByUserIdAsc = 'CREATED_BY_USER_ID_ASC',
  CreatedByUserIdDesc = 'CREATED_BY_USER_ID_DESC',
  HashAsc = 'HASH_ASC',
  HashDesc = 'HASH_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SnapshotIdAsc = 'SNAPSHOT_ID_ASC',
  SnapshotIdDesc = 'SNAPSHOT_ID_DESC'
}

export enum Browser {
  Chrome = 'CHROME',
  Edge = 'EDGE',
  Firefox = 'FIREFOX',
  Safari = 'SAFARI'
}

/** The result of diffing a `Baseline` with a `Snapshot`. */
export type Build = Node & {
  __typename?: 'Build';
  branch: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdByOrgId: Scalars['UUID'];
  createdByUser: User;
  createdByUserId: Scalars['UUID'];
  diffCount: Scalars['Int'];
  /** Reads and enables pagination through a set of `Diff`. */
  diffs: DiffsConnection;
  /**
   * If not null, it indicates that the build encountered an error.
   *
   * By convention, the following errors exist:
   * - `{"code": "TIMEOUT"}`: The build timed out, because `finishBuild` was not called.
   * - `{"code": "DIFF_TIMEOUT"}`: At least one diff could not be computed within the time limit.
   *
   * Other error types may exist and the frontend should display a generic error message
   * together with the JSON contents of `error`.
   */
  error: Maybe<Scalars['JSON']>;
  /** Full-text search ranking when filtered by `fullText`. */
  fullTextRank: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  mode: BuildMode;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  owningTeamId: Scalars['UUID'];
  project: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Snapshot`. */
  snapshots: SnapshotsConnection;
  status: BuildStatus;
  url: Scalars['String'];
};


/** The result of diffing a `Baseline` with a `Snapshot`. */
export type BuildDiffCountArgs = {
  status: DiffStatus;
};


/** The result of diffing a `Baseline` with a `Snapshot`. */
export type BuildDiffsArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<DiffCondition>;
  filter: InputMaybe<DiffFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiffsOrderBy>>;
};


/** The result of diffing a `Baseline` with a `Snapshot`. */
export type BuildSnapshotsArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<SnapshotCondition>;
  filter: InputMaybe<SnapshotFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SnapshotsOrderBy>>;
};

/** A condition to be used against `Build` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BuildCondition = {
  /** Checks for equality with the object’s `branch` field. */
  branch: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdByOrgId` field. */
  createdByOrgId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fullText` field. */
  fullText: InputMaybe<Scalars['FullText']>;
  /** Checks for equality with the object’s `id` field. */
  id: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `owningTeamId` field. */
  owningTeamId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `project` field. */
  project: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `status` field. */
  status: InputMaybe<BuildStatus>;
};

/** A filter to be used against `Build` object types. All fields are combined with a logical ‘and.’ */
export type BuildFilter = {
  /** Filter by the object’s `branch` field. */
  branch: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByOrgId` field. */
  createdByOrgId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fullText` field. */
  fullText: InputMaybe<FullTextFilter>;
  /** Filter by the object’s `id` field. */
  id: InputMaybe<UuidFilter>;
  /** Filter by the object’s `owningTeamId` field. */
  owningTeamId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `project` field. */
  project: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status: InputMaybe<BuildStatusFilter>;
};

export type BuildIn = {
  branch: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  project: InputMaybe<Scalars['String']>;
};

export enum BuildMode {
  Completed = 'COMPLETED',
  Running = 'RUNNING'
}

/**
 * Lifecycle status of a `Build`.
 *
 * 1. A new `Build` is always in `RUNNING` state.
 * 2. When the `finishBuild` mutation was called, its state is as follows:
 *    - `ERRORED` if build.error is not null or else
 *    - `UNAPPROVED` if any Diff in the Build is UNAPPROVED or else
 *    - `REJECTED` if any Diff in the Build is REJECTED or else
 *    - `APPROVED` if any Diff in the Build is APPROVED and
 *    - `EQUAL` in any other case
 *
 * When `finishBuild` is not called, the build will time out and end up in the `ERRORED` state.
 */
export enum BuildStatus {
  Approved = 'APPROVED',
  Equal = 'EQUAL',
  Errored = 'ERRORED',
  Queued = 'QUEUED',
  Rejected = 'REJECTED',
  Running = 'RUNNING',
  Unapproved = 'UNAPPROVED'
}

/** A filter to be used against BuildStatus fields. All fields are combined with a logical ‘and.’ */
export type BuildStatusFilter = {
  /** Greater than the specified value. */
  greaterThan: InputMaybe<BuildStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo: InputMaybe<BuildStatus>;
  /** Included in the specified list. */
  in: InputMaybe<Array<BuildStatus>>;
  /** Less than the specified value. */
  lessThan: InputMaybe<BuildStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo: InputMaybe<BuildStatus>;
};

/** A connection to a list of `Build` values. */
export type BuildsConnection = {
  __typename?: 'BuildsConnection';
  /** A list of edges which contains the `Build` and cursor to aid in pagination. */
  edges: Array<BuildsEdge>;
  /** A list of `Build` objects. */
  nodes: Array<Build>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Build` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Build` edge in the connection. */
export type BuildsEdge = {
  __typename?: 'BuildsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Build` at the end of the edge. */
  node: Build;
};

/** Methods to use when ordering `Build`. */
export enum BuildsOrderBy {
  BranchAsc = 'BRANCH_ASC',
  BranchDesc = 'BRANCH_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByOrgIdAsc = 'CREATED_BY_ORG_ID_ASC',
  CreatedByOrgIdDesc = 'CREATED_BY_ORG_ID_DESC',
  CreatedByUserIdAsc = 'CREATED_BY_USER_ID_ASC',
  CreatedByUserIdDesc = 'CREATED_BY_USER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OwningTeamIdAsc = 'OWNING_TEAM_ID_ASC',
  OwningTeamIdDesc = 'OWNING_TEAM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProjectAsc = 'PROJECT_ASC',
  ProjectDesc = 'PROJECT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type CreateSnapshotUploadFromWebDriverIn = {
  buildId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Greater than the specified value. */
  greaterThan: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in: InputMaybe<Array<Scalars['Datetime']>>;
  /** Less than the specified value. */
  lessThan: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo: InputMaybe<Scalars['Datetime']>;
};

/**
 * The result of diffing a `Baseline` with a `Snapshot`.
 *
 * See the documentation for `Baseline` for details how a `Snapshot` is matched to `Baseline`.
 */
export type Diff = Node & {
  __typename?: 'Diff';
  /** Reads a single `Baseline` that is related to this `Diff`. */
  baseline: Maybe<Baseline>;
  baselineId: Maybe<Scalars['UUID']>;
  /** Reads a single `Build` that is related to this `Diff`. */
  build: Maybe<Build>;
  buildId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  diffBounds: Maybe<Rect>;
  diffClusters: Array<Maybe<Rect>>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Snapshot` that is related to this `Diff`. */
  snapshot: Maybe<Snapshot>;
  snapshotId: Scalars['UUID'];
  status: DiffStatus;
  statusIsEqual: Maybe<Scalars['Boolean']>;
  /**
   * Last time the diff was updated.
   *
   * By default `updatedAt = createdAt`.
   */
  updatedAt: Scalars['Datetime'];
  /** User id of user that last updated the diff. If no user updated the status yet, it is set to `created_by`. */
  updatedBy: Scalars['UUID'];
  updatedByUser: User;
};

/** A condition to be used against `Diff` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DiffCondition = {
  /** Checks for equality with the object’s `baselineId` field. */
  baselineId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `buildId` field. */
  buildId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `snapshotId` field. */
  snapshotId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status: InputMaybe<DiffStatus>;
};

/** A filter to be used against `Diff` object types. All fields are combined with a logical ‘and.’ */
export type DiffFilter = {
  /** Filter by the object’s `baselineId` field. */
  baselineId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `buildId` field. */
  buildId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id: InputMaybe<UuidFilter>;
  /** Filter by the object’s `snapshotId` field. */
  snapshotId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status: InputMaybe<DiffStatusFilter>;
};

/**
 * Lifecycle status of a `Diff`.
 *
 * 1. When a `Diff` is created from a `Snapshot` it will be `QUEUED`.
 * 2. After the difference between snapshot and baseline was computed, the state is either
 *     `EQUAL` (`Baseline` and snapshot are equal) or
 *     `UNAPPROVED` (differences between `Baseline` and `Snapshot` were detected or no `Baseline` exists).
 * 3. A user can update the status of an existing `Diff` to either
 *     `APPROVED` (a new `Baseline` is then created from the `Snapshot`)
 *     `REJECTED` (no new `Baseline` is created)
 *     `UNAPPROVED` (if it was approved before, the previous `Baseline` is restored)
 */
export enum DiffStatus {
  Approved = 'APPROVED',
  Equal = 'EQUAL',
  Queued = 'QUEUED',
  Rejected = 'REJECTED',
  Unapproved = 'UNAPPROVED'
}

/** A filter to be used against DiffStatus fields. All fields are combined with a logical ‘and.’ */
export type DiffStatusFilter = {
  /** Greater than the specified value. */
  greaterThan: InputMaybe<DiffStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo: InputMaybe<DiffStatus>;
  /** Included in the specified list. */
  in: InputMaybe<Array<DiffStatus>>;
  /** Less than the specified value. */
  lessThan: InputMaybe<DiffStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo: InputMaybe<DiffStatus>;
};

/** A connection to a list of `Diff` values. */
export type DiffsConnection = {
  __typename?: 'DiffsConnection';
  /** A list of edges which contains the `Diff` and cursor to aid in pagination. */
  edges: Array<DiffsEdge>;
  /** A list of `Diff` objects. */
  nodes: Array<Diff>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Diff` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Diff` edge in the connection. */
export type DiffsEdge = {
  __typename?: 'DiffsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Diff` at the end of the edge. */
  node: Diff;
};

/** Methods to use when ordering `Diff`. */
export enum DiffsOrderBy {
  BaselineIdAsc = 'BASELINE_ID_ASC',
  BaselineIdDesc = 'BASELINE_ID_DESC',
  BuildIdAsc = 'BUILD_ID_ASC',
  BuildIdDesc = 'BUILD_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SnapshotIdAsc = 'SNAPSHOT_ID_ASC',
  SnapshotIdDesc = 'SNAPSHOT_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusIsEqualAsc = 'STATUS_IS_EQUAL_ASC',
  StatusIsEqualDesc = 'STATUS_IS_EQUAL_DESC'
}

export type FinishBuildIn = {
  id: Scalars['ID'];
};

/** A filter to be used against FullText fields. All fields are combined with a logical ‘and.’ */
export type FullTextFilter = {
  /** Performs a full text search on the field. */
  matches: InputMaybe<Scalars['String']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  createBuild: Build;
  createSnapshot: Snapshot;
  createSnapshotUpload: SnapshotUpload;
  createSnapshotUploadFromWebDriver: SnapshotUpload;
  finishBuild: Build;
  updateDiff: Diff;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuildArgs = {
  input: BuildIn;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSnapshotArgs = {
  input: SnapshotIn;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSnapshotUploadArgs = {
  input: SnapshotUploadIn;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSnapshotUploadFromWebDriverArgs = {
  input: CreateSnapshotUploadFromWebDriverIn;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFinishBuildArgs = {
  input: FinishBuildIn;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDiffArgs = {
  input: UpdateDiffIn;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export enum OperatingSystem {
  Android = 'ANDROID',
  Ios = 'IOS',
  Linux = 'LINUX',
  Macos = 'MACOS',
  Windows = 'WINDOWS'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['Cursor']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  baseline: Maybe<Baseline>;
  /** Reads a single `Baseline` using its globally unique `ID`. */
  baselineByNodeId: Maybe<Baseline>;
  /** Reads and enables pagination through a set of `Baseline`. */
  baselines: Maybe<BaselinesConnection>;
  /** List all the branches to search by for the current user. */
  branches: Array<Maybe<Scalars['String']>>;
  build: Maybe<Build>;
  /** Reads a single `Build` using its globally unique `ID`. */
  buildByNodeId: Maybe<Build>;
  /** Reads and enables pagination through a set of `Build`. */
  builds: Maybe<BuildsConnection>;
  diff: Maybe<Diff>;
  /** Reads a single `Diff` using its globally unique `ID`. */
  diffByNodeId: Maybe<Diff>;
  /** Reads and enables pagination through a set of `Diff`. */
  diffs: Maybe<DiffsConnection>;
  jwtOrgId: Maybe<Scalars['UUID']>;
  jwtTeamId: Maybe<Scalars['UUID']>;
  jwtUserId: Maybe<Scalars['UUID']>;
  /** Fetches an object given its globally unique `ID`. */
  node: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** List all the projects to search by for the current user. */
  projects: Array<Maybe<Scalars['String']>>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  snapshot: Maybe<Snapshot>;
  /** Reads a single `Snapshot` using its globally unique `ID`. */
  snapshotByNodeId: Maybe<Snapshot>;
  /** Reads and enables pagination through a set of `Snapshot`. */
  snapshots: Maybe<SnapshotsConnection>;
  webdriverSession: Maybe<WebdriverSession>;
  webdriverSessionFromArchive: Maybe<WebdriverSession>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBaselineArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBaselineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBaselinesArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<BaselineCondition>;
  filter: InputMaybe<BaselineFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BaselinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBranchesArgs = {
  filtername: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBuildsArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<BuildCondition>;
  filter: InputMaybe<BuildFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BuildsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDiffArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDiffByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDiffsArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<DiffCondition>;
  filter: InputMaybe<DiffFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiffsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectsArgs = {
  filtername: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySnapshotArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySnapshotByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySnapshotsArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<SnapshotCondition>;
  filter: InputMaybe<SnapshotFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SnapshotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWebdriverSessionArgs = {
  sessionId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebdriverSessionFromArchiveArgs = {
  jobId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

export type Rect = {
  __typename?: 'Rect';
  height: Scalars['Int'];
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type Region = {
  __typename?: 'Region';
  height: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type RegionIn = {
  height: Scalars['Int'];
  name: InputMaybe<Scalars['String']>;
  width: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type Snapshot = Node & {
  __typename?: 'Snapshot';
  baselineHash: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Baseline`. */
  baselines: BaselinesConnection;
  branch: Maybe<Scalars['String']>;
  browser: Maybe<Browser>;
  browserVersion: Maybe<Scalars['String']>;
  /** Reads a single `Build` that is related to this `Snapshot`. */
  build: Maybe<Build>;
  buildId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  device: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Diff`. */
  diffs: DiffsConnection;
  id: Scalars['UUID'];
  ignoreRegions: Array<Maybe<Region>>;
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operatingSystem: Maybe<OperatingSystem>;
  operatingSystemVersion: Maybe<Scalars['String']>;
  suiteName: Maybe<Scalars['String']>;
  testName: Maybe<Scalars['String']>;
  uploadId: Scalars['String'];
  url: Scalars['String'];
  viewportHeight: Maybe<Scalars['Int']>;
  viewportWidth: Maybe<Scalars['Int']>;
};


export type SnapshotBaselinesArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<BaselineCondition>;
  filter: InputMaybe<BaselineFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BaselinesOrderBy>>;
};


export type SnapshotDiffsArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<DiffCondition>;
  filter: InputMaybe<DiffFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiffsOrderBy>>;
};

/**
 * A condition to be used against `Snapshot` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SnapshotCondition = {
  /** Checks for equality with the object’s `buildId` field. */
  buildId: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `Snapshot` object types. All fields are combined with a logical ‘and.’ */
export type SnapshotFilter = {
  /** Filter by the object’s `buildId` field. */
  buildId: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id: InputMaybe<UuidFilter>;
};

export type SnapshotIn = {
  browser: InputMaybe<Browser>;
  browserVersion: InputMaybe<Scalars['String']>;
  buildId: Scalars['ID'];
  device: InputMaybe<Scalars['String']>;
  ignoreRegions: InputMaybe<Array<RegionIn>>;
  name: Scalars['String'];
  operatingSystem: InputMaybe<OperatingSystem>;
  operatingSystemVersion: InputMaybe<Scalars['String']>;
  suiteName: InputMaybe<Scalars['String']>;
  testName: InputMaybe<Scalars['String']>;
  uploadId: Scalars['ID'];
  viewportHeight: InputMaybe<Scalars['Int']>;
  viewportWidth: InputMaybe<Scalars['Int']>;
};

export type SnapshotUpload = {
  __typename?: 'SnapshotUpload';
  buildId: Scalars['ID'];
  id: Scalars['ID'];
  uploadUrl: Scalars['String'];
};

export type SnapshotUploadIn = {
  buildId: Scalars['ID'];
};

/** A connection to a list of `Snapshot` values. */
export type SnapshotsConnection = {
  __typename?: 'SnapshotsConnection';
  /** A list of edges which contains the `Snapshot` and cursor to aid in pagination. */
  edges: Array<SnapshotsEdge>;
  /** A list of `Snapshot` objects. */
  nodes: Array<Snapshot>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Snapshot` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Snapshot` edge in the connection. */
export type SnapshotsEdge = {
  __typename?: 'SnapshotsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Snapshot` at the end of the edge. */
  node: Snapshot;
};

/** Methods to use when ordering `Snapshot`. */
export enum SnapshotsOrderBy {
  BuildIdAsc = 'BUILD_ID_ASC',
  BuildIdDesc = 'BUILD_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Greater than the specified value. */
  greaterThan: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in: InputMaybe<Array<Scalars['String']>>;
  /** Less than the specified value. */
  lessThan: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo: InputMaybe<Scalars['String']>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Greater than the specified value. */
  greaterThan: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in: InputMaybe<Array<Scalars['UUID']>>;
  /** Less than the specified value. */
  lessThan: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo: InputMaybe<Scalars['UUID']>;
};

export type UpdateDiffIn = {
  id: Scalars['ID'];
  status: UpdateDiffStatus;
};

/** See DiffStatus for details. */
export enum UpdateDiffStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Unapproved = 'UNAPPROVED'
}

export type User = {
  __typename?: 'User';
  id: Scalars['UUID'];
  username: Maybe<Scalars['String']>;
};

export type WebdriverSession = {
  __typename?: 'WebdriverSession';
  browser: Maybe<Browser>;
  browserVersion: Maybe<Scalars['String']>;
  operatingSystem: Maybe<OperatingSystem>;
  operatingSystemVersion: Maybe<Scalars['String']>;
  viewportHeight: Maybe<Scalars['Int']>;
  viewportWidth: Maybe<Scalars['Int']>;
};

export type BuildFragFragment = { __typename?: 'Build', id: string, name: string, status: BuildStatus, error: any | null, project: string | null, approved: number, equal: number, rejected: number, unapproved: number, diffIds: { __typename?: 'DiffsConnection', totalCount: number, nodes: Array<{ __typename?: 'Diff', id: string }> } } & { ' $fragmentName'?: 'BuildFragFragment' };

export type ReadBuildDocumentQueryVariables = Exact<{
  id: Scalars['UUID'];
  order: InputMaybe<Array<DiffsOrderBy> | DiffsOrderBy>;
  filter: DiffFilter;
}>;


export type ReadBuildDocumentQuery = { __typename?: 'Query', build: (
    { __typename?: 'Build' }
    & { ' $fragmentRefs'?: { 'BuildFragFragment': BuildFragFragment } }
  ) | null };

export type ListProjectsQueryVariables = Exact<{
  filterName: InputMaybe<Scalars['String']>;
}>;


export type ListProjectsQuery = { __typename?: 'Query', projects: Array<string | null> };

export type ListBranchesQueryVariables = Exact<{
  filterName: InputMaybe<Scalars['String']>;
}>;


export type ListBranchesQuery = { __typename?: 'Query', branches: Array<string | null> };

export type ReadBuildsQueryVariables = Exact<{
  diffOffset: Scalars['Int'];
  startDate: Scalars['Datetime'];
  endDate: Scalars['Datetime'];
  createdByOrgId: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  createdByUserId: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  owningTeamId: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  nameSearchValue: InputMaybe<Scalars['String']>;
  status: InputMaybe<Array<BuildStatus> | BuildStatus>;
  project: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  branch: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ReadBuildsQuery = { __typename?: 'Query', builds: { __typename?: 'BuildsConnection', totalCount: number, nodes: Array<(
      { __typename?: 'Build', id: string }
      & { ' $fragmentRefs'?: { 'BuildsViewBuildFragmentFragment': BuildsViewBuildFragmentFragment } }
    )> } | null };

export type BuildsViewBuildFragmentFragment = { __typename?: 'Build', id: string, name: string, status: BuildStatus, branch: string | null, createdAt: Date | string | number, project: string | null, approved: number, unapproved: number, rejected: number, equal: number, createdByUser: { __typename?: 'User', id: string, username: string | null }, diffs: { __typename?: 'DiffsConnection', totalCount: number } } & { ' $fragmentName'?: 'BuildsViewBuildFragmentFragment' };

export type DiffFragFragment = (
  { __typename?: 'Diff', id: string }
  & { ' $fragmentRefs'?: { 'DiffViewFragmentFragment': DiffViewFragmentFragment;'DiffStageMetaFragmentFragment': DiffStageMetaFragmentFragment } }
) & { ' $fragmentName'?: 'DiffFragFragment' };

export type ReadDiffDocumentQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReadDiffDocumentQuery = { __typename?: 'Query', diff: (
    { __typename?: 'Diff' }
    & { ' $fragmentRefs'?: { 'DiffFragFragment': DiffFragFragment } }
  ) | null };

export type UpdateDiffMutationMutationVariables = Exact<{
  id: Scalars['ID'];
  status: UpdateDiffStatus;
  order: InputMaybe<Array<DiffsOrderBy> | DiffsOrderBy>;
  filter: DiffFilter;
}>;


export type UpdateDiffMutationMutation = { __typename?: 'Mutation', updateDiff: (
    { __typename?: 'Diff', build: (
      { __typename?: 'Build' }
      & { ' $fragmentRefs'?: { 'BuildFragFragment': BuildFragFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'DiffStageMetaFragmentFragment': DiffStageMetaFragmentFragment } }
  ) };

export type DiffStageMetaFragmentFragment = { __typename?: 'Diff', id: string, status: DiffStatus, updatedAt: Date | string | number, updatedByUser: { __typename?: 'User', id: string, username: string | null }, baseline: { __typename?: 'Baseline', id: string, createdAt: Date | string | number, branch: string | null, createdByUser: { __typename?: 'User', id: string, username: string | null } } | null, snapshot: { __typename?: 'Snapshot', id: string, branch: string | null, createdAt: Date | string | number } | null, diffClusters: Array<(
    { __typename?: 'Rect' }
    & { ' $fragmentRefs'?: { 'RectFragFragment': RectFragFragment } }
  ) | null> } & { ' $fragmentName'?: 'DiffStageMetaFragmentFragment' };

export type DiffViewSnapshotFragment = { __typename?: 'Snapshot', id: string, name: string, testName: string | null, suiteName: string | null, branch: string | null, browser: Browser | null, browserVersion: string | null, device: string | null, operatingSystem: OperatingSystem | null, operatingSystemVersion: string | null, viewportWidth: number | null, viewportHeight: number | null, imageUrl: string, ignoreRegions: Array<(
    { __typename?: 'Region' }
    & { ' $fragmentRefs'?: { 'RegionFragFragment': RegionFragFragment } }
  ) | null> } & { ' $fragmentName'?: 'DiffViewSnapshotFragment' };

export type DiffViewBaselineFragment = { __typename?: 'Baseline', id: string, name: string, testName: string | null, suiteName: string | null, browser: Browser | null, browserVersion: string | null, operatingSystem: OperatingSystem | null, operatingSystemVersion: string | null, viewportWidth: number | null, viewportHeight: number | null, imageUrl: string, createdAt: Date | string | number, createdByUser: { __typename?: 'User', id: string, username: string | null } } & { ' $fragmentName'?: 'DiffViewBaselineFragment' };

export type RegionFragFragment = { __typename?: 'Region', x: number, y: number, width: number, height: number, name: string | null } & { ' $fragmentName'?: 'RegionFragFragment' };

export type RectFragFragment = { __typename?: 'Rect', x: number, y: number, width: number, height: number } & { ' $fragmentName'?: 'RectFragFragment' };

export type DiffViewFragmentFragment = (
  { __typename?: 'Diff', id: string, createdAt: Date | string | number, status: DiffStatus, updatedAt: Date | string | number, updatedByUser: { __typename?: 'User', id: string, username: string | null }, diffBounds: (
    { __typename?: 'Rect' }
    & { ' $fragmentRefs'?: { 'RectFragFragment': RectFragFragment } }
  ) | null, diffClusters: Array<(
    { __typename?: 'Rect' }
    & { ' $fragmentRefs'?: { 'RectFragFragment': RectFragFragment } }
  ) | null>, baseline: (
    { __typename?: 'Baseline' }
    & { ' $fragmentRefs'?: { 'DiffViewBaselineFragment': DiffViewBaselineFragment } }
  ) | null, snapshot: (
    { __typename?: 'Snapshot' }
    & { ' $fragmentRefs'?: { 'DiffViewSnapshotFragment': DiffViewSnapshotFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'DiffStageMetaFragmentFragment': DiffStageMetaFragmentFragment } }
) & { ' $fragmentName'?: 'DiffViewFragmentFragment' };

export const BuildFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Build"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"project"}},{"kind":"Field","alias":{"kind":"Name","value":"approved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"APPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"equal"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"EQUAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"rejected"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"REJECTED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"unapproved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"UNAPPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"diffIds"},"name":{"kind":"Name","value":"diffs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BuildFragFragment, unknown>;
export const BuildsViewBuildFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildsViewBuildFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Build"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"}},{"kind":"Field","name":{"kind":"Name","value":"diffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"approved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"APPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"unapproved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"UNAPPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"rejected"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"REJECTED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"equal"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"EQUAL"}}]}]}}]} as unknown as DocumentNode<BuildsViewBuildFragmentFragment, unknown>;
export const RectFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RectFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<RectFragFragment, unknown>;
export const DiffViewBaselineFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Baseline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<DiffViewBaselineFragment, unknown>;
export const RegionFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegionFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<RegionFragFragment, unknown>;
export const DiffViewSnapshotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Snapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Snapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ignoreRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegionFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegionFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<DiffViewSnapshotFragment, unknown>;
export const DiffStageMetaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffStageMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RectFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]} as unknown as DocumentNode<DiffStageMetaFragmentFragment, unknown>;
export const DiffViewFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffViewFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"diffBounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffView_Baseline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffView_Snapshot"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffStageMetaFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegionFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RectFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Baseline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Snapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Snapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ignoreRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegionFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffStageMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}}]}}]} as unknown as DocumentNode<DiffViewFragmentFragment, unknown>;
export const DiffFragFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffViewFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffStageMetaFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RectFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Baseline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegionFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Snapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Snapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ignoreRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegionFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffStageMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffViewFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"diffBounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffView_Baseline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffView_Snapshot"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffStageMetaFragment"}}]}}]} as unknown as DocumentNode<DiffFragFragment, unknown>;
export const ReadBuildDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadBuildDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiffsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiffFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"build"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Build"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"project"}},{"kind":"Field","alias":{"kind":"Name","value":"approved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"APPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"equal"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"EQUAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"rejected"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"REJECTED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"unapproved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"UNAPPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"diffIds"},"name":{"kind":"Name","value":"diffs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ReadBuildDocumentQuery, ReadBuildDocumentQueryVariables>;
export const ListProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filtername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterName"}}}]}]}}]} as unknown as DocumentNode<ListProjectsQuery, ListProjectsQueryVariables>;
export const ListBranchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListBranches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"branches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filtername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterName"}}}]}]}}]} as unknown as DocumentNode<ListBranchesQuery, ListBranchesQueryVariables>;
export const ReadBuildsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadBuilds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"diffOffset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByOrgId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByUserId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owningTeamId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nameSearchValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BuildStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"branch"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"builds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"diffOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByOrgId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByOrgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByUserId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owningTeamId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owningTeamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fullText"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"matches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nameSearchValue"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"project"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"branch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"branch"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildsViewBuildFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildsViewBuildFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Build"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"project"}},{"kind":"Field","name":{"kind":"Name","value":"diffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"approved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"APPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"unapproved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"UNAPPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"rejected"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"REJECTED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"equal"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"EQUAL"}}]}]}}]} as unknown as DocumentNode<ReadBuildsQuery, ReadBuildsQueryVariables>;
export const ReadDiffDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadDiffDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RectFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Baseline"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RegionFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Region"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffView_Snapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Snapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testName"}},{"kind":"Field","name":{"kind":"Name","value":"suiteName"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"browser"}},{"kind":"Field","name":{"kind":"Name","value":"browserVersion"}},{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystem"}},{"kind":"Field","name":{"kind":"Name","value":"operatingSystemVersion"}},{"kind":"Field","name":{"kind":"Name","value":"viewportWidth"}},{"kind":"Field","name":{"kind":"Name","value":"viewportHeight"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ignoreRegions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RegionFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffStageMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffViewFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"diffBounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffView_Baseline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffView_Snapshot"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffStageMetaFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffViewFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffStageMetaFragment"}}]}}]} as unknown as DocumentNode<ReadDiffDocumentQuery, ReadDiffDocumentQueryVariables>;
export const UpdateDiffMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDiffMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDiffStatus"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiffsOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiffFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDiff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiffStageMetaFragment"}},{"kind":"Field","name":{"kind":"Name","value":"build"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuildFrag"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RectFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Rect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiffStageMetaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Diff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"snapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diffClusters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RectFrag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuildFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Build"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"project"}},{"kind":"Field","alias":{"kind":"Name","value":"approved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"APPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"equal"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"EQUAL"}}]},{"kind":"Field","alias":{"kind":"Name","value":"rejected"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"REJECTED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"unapproved"},"name":{"kind":"Name","value":"diffCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"UNAPPROVED"}}]},{"kind":"Field","alias":{"kind":"Name","value":"diffIds"},"name":{"kind":"Name","value":"diffs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UpdateDiffMutationMutation, UpdateDiffMutationMutationVariables>;